export const NEXT_PAGE="app/ports/NEXT_PAGE"
export const BACK_PAGE="app/ports/BACK_PAGE"
export const RESET_PAGE="app/ports/RESET_PAGE"
export const PORTS_LOADING="app/ports/PORTS_LOADING"
export const SET_VIEW="app/ports/SET_VIEW"
